import i18next from '../../config/i18next';
import i18nConsistencyReport from './i18n/fr.json';

//Pages
import ConsistencyReportPage from './pages/consistency-report-page/consistency-report-page';

i18next.addResourceBundle('fr', 'cr', i18nConsistencyReport);

export { ConsistencyReportPage };
